<template>
    <div class="error-msg-wrap">
        <div v-if="isLoaded" class="form-wrapper slide-up" style="width:500px">
            <div class="form-close">
                <button type="button" class="form-close-x" title="Close" @click="$emit('close')">&times;</button>
            </div>
            <h3>Who Can View</h3>
            <div v-if="node.DepartmentsJSON.length == 1" style="margin-bottom:15px">
                {{ node.Name }} is tagged to the <b>{{ node.DeparmentsString }}</b> department. Anyone assigned to that department can see it.
            </div>
            <div v-else-if="node.DepartmentsJSON.length > 1" style="margin-bottom:15px">
                {{ node.Name }} is tagged to these departments: <b>{{ node.DeparmentsString }}.</b> Anyone assigned to those departments can see it.
            </div>
            <div class="my-checklists-label">STANDARD USERS ({{ nodePublicUsers.length }})</div>
            <div v-if="nodePublicUsers.length" class="who-can-view-list" style="margin-bottom:20px">
                <div v-for="(u, i) in nodePublicUsers" :key="i">{{ u.FirstName }} {{ u.LastName }}</div>
            </div>
            <div class="my-checklists-label">ADMINS & EDITORS ({{ nodeUsers.length }})</div>
            <div v-if="nodeUsers.length" class="who-can-view-list">
                <div v-for="(u, i) in nodeUsers" :key="i">{{ u.FirstName }} {{ u.LastName }}</div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import axios from 'axios';
import { adminUsersForNode, publicUsersForNode } from '@/nodeViewers';

export default defineComponent({
    name: 'WhoCanView',
    props: [ 'slug' ],
    data() {
        return {
            isLoaded: false,
            usersAll: [] as any,
            publicUsersAll: [] as any,
            nodeUsers: [] as any,
            nodePublicUsers: [] as any,
            node: null as any
        }
    },
    async created() {
        await axios.get(`${this.$store.state.apiUrl}/api/playbook/node/${this.slug}`)
            .then(resp => {
                if(resp.data.DepartmentsJSON) {
                    resp.data.DepartmentsJSON = JSON.parse(resp.data.DepartmentsJSON);
                    resp.data.DeparmentsString = resp.data.DepartmentsJSON.join(', ');
                } else {
                    resp.data.DepartmentsJSON = [];
                }
                if(resp.data.LocationsJSON) {
                    resp.data.LocationsJSON = JSON.parse(resp.data.LocationsJSON);
                } else {
                    resp.data.LocationsJSON = [];
                }
                this.node = resp.data;
            })
            .catch(e => {
                console.log(e);
            })

        await axios.get(`${this.$store.state.apiUrl}/api/users`)
            .then(resp => {
                this.usersAll = resp.data;
            })
            .catch(e => {
                console.log(e);
            })

        await axios.get(`${this.$store.state.apiUrl}/api/publicusers`)
            .then(resp => {
                this.publicUsersAll = resp.data;
            })
            .catch(e => {
                console.log(e);
            })

        this.setUsers();

        this.isLoaded = true;
    },
    methods: {
        setUsers() {
            this.nodeUsers = adminUsersForNode(this.usersAll, this.node.DepartmentsJSON);
            this.nodePublicUsers = publicUsersForNode(this.publicUsersAll, this.node.LocationsJSON, this.node.DepartmentsJSON);
        }
    }
});
</script>
